if (!process.env.VUE_APP_IS_WEB) {
  var MeetingCorrespondenceVoteDB = require("../database/models/MeetingCorrespondenceVote");
}

import MeetingCorrespondenceVoteORM from "@/store/orm-axios/models/MeetingCorrespondenceVote";

export default {
  FETCH_BY_MEETING(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingCorrespondenceVoteDB()
          .query({ where: { meeting_id: meetingId, deleted: null } })
          .fetchAll()
          .then(res => {
            MeetingCorrespondenceVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingCorrespondenceVoteORM.api()
          .FETCH_BY_MEETING(meetingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new MeetingCorrespondenceVoteDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            MeetingCorrespondenceVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingCorrespondenceVoteORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));

      delete itemPost["id"];

      return new Promise((resolve, reject) => {
        new MeetingCorrespondenceVoteDB(itemPost)
          .save()
          .then(res => {
            MeetingCorrespondenceVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingCorrespondenceVoteORM.api()
          .POST(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new MeetingCorrespondenceVoteDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            MeetingCorrespondenceVoteORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingCorrespondenceVoteORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));

      return new Promise((resolve, reject) => {
        new MeetingCorrespondenceVoteDB(itemDelete)
          .save(null, { isDelete: true })
          .then(async res => {
            MeetingCorrespondenceVoteORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        MeetingCorrespondenceVoteORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
